import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { InterestsFieldComponent } from "src/app/pages/register-user/shared/components";

@Component({
  selector: 'app-form-step-4',
  standalone: true,
  imports: [
    InterestsFieldComponent
],
  templateUrl: './form-step-4.component.html',
  styleUrls: ['./form-step-4.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormStep4Component {
  public form = input<FormGroup>();

}
